/*
 * ZelPath lessons — short, practical, plain-language.
 * lessonId must match /^[a-z0-9-]+$/ (backend-validated).
 */

const lessons = [
  {
    id: "phishing",
    icon: "🎣",
    title: "Phishing: Don't Take the Bait",
    minutes: 5,
    body: [
      {
        heading: "What it is",
        text: "Phishing is a fake message (email, text, or pop-up) designed to trick you into clicking a bad link, entering a password, or giving money. It's the #1 way people get hacked — and it works because it looks real.",
      },
      {
        heading: "The 4 warning signs",
        list: [
          "URGENCY: 'Act now', 'your account will be closed today', 'final warning'",
          "AUTHORITY IMPERSONATION: your bank, Microsoft, Apple, the IRS, Netflix",
          "A LINK that doesn't match the sender (hover over it — read the real address)",
          "AN ASK: a password, a code, a payment, or personal info",
        ],
      },
      {
        heading: "What to do",
        list: [
          "Never click links in unexpected messages — go to the website yourself by typing it",
          "Never share verification codes. No real company will ask for them",
          "When in doubt, contact the company using the number on your card or their official app",
        ],
      },
      {
        heading: "Remember",
        text: "Scammers trick smart people every day. Falling for one doesn't mean you're not smart — it means they're professional criminals. When in doubt, get a second opinion (that's what our Scam Check tool is for).",
      },
    ],
  },
  {
    id: "passwords",
    icon: "🔑",
    title: "Passwords: Strong, Unique, Managed",
    minutes: 5,
    body: [
      {
        heading: "The one rule that matters most",
        text: "Never reuse passwords. When one site gets hacked (and sites get hacked constantly), criminals try that email+password on your bank, your email, and everything else. Unique passwords stop one leak from becoming ten.",
      },
      {
        heading: "What a strong password looks like",
        list: [
          "Long: 14+ characters beats 'complex' short ones",
          "A passPHRASE you can remember: 'Purple-Tacos-Swim-Midnight-42!' works",
          "Never: birthdays, pet names, 'Password123', or anything you've used elsewhere",
        ],
      },
      {
        heading: "The tool that does the work: a password manager",
        text: "A password manager remembers everything so you only memorize ONE master password. Free options: Bitwarden, or the one built into your browser/phone (iCloud Keychain, Google Password Manager).",
      },
      {
        heading: "Add a second lock: 2FA",
        text: "Turn on two-factor authentication for your email and bank first. Even if criminals steal your password, they still can't get in. Use an authenticator app when possible — text codes are okay, app codes are stronger.",
      },
    ],
  },
  {
    id: "backups",
    icon: "💾",
    title: "Backups: Your Digital Insurance",
    minutes: 4,
    body: [
      {
        heading: "Why it matters",
        text: "Computers die, drives fail, ransomware locks files, laptops get stolen. A backup is the difference between 'annoying' and 'devastating' — family photos, tax records, and years of work are gone without one.",
      },
      {
        heading: "The simple rule: 3-2-1",
        list: [
          "3 copies of anything important",
          "2 different places (your computer + the cloud, or your computer + an external drive)",
          "1 copy somewhere else entirely (cloud or offsite)",
        ],
      },
      {
        heading: "Easiest ways to start today",
        list: [
          "Windows: File History + OneDrive · Mac: Time Machine + iCloud",
          "Cloud storage: OneDrive, Google Drive, iCloud — the free tiers cover most documents and photos",
          "An external USB drive: plug it in monthly, copy your important folder, unplug it",
        ],
      },
      {
        heading: "The test",
        text: "A backup you've never restored is a hope, not a backup. Once a year, try opening one backed-up file from the backup itself. Two minutes of checking buys real peace of mind.",
      },
    ],
  },
];

export default lessons;
